<template>
  <div>
    <Stars v-for="star in [1, 2, 3, 4, 5]" @setActiveStar="setActiveStar(star)" :key="star"
      :active="initialStar >= star" :size="size" />
  </div>
</template>

<script>
import Stars from "./Stars.vue";

export default {
  name: 'star-rate',
  props: {
    size: {
      type: Number
    },
    canChange: { type: Boolean },
    value: {
      type: String,
      default: "1",
    },
    onChange: {  }
  },
  components: { Stars },
  watch: {
    initialStar(val) {
      this.$emit('onChange', val)
    }
  },
  data() {
    return {
      initialStar: 1,
    };
  },
  mounted() {
    if (this.value) {
      this.initialStar = this.value
      this.onChange(this.value)
    }
  },
  methods: {
    setActiveStar(val) {
      this.canChange ? this.initialStar = val : null;
      this.onChange(val)
    },
  },
};
</script>

<style lang="scss" scoped></style>
